export default {
  index: [
    {
      path: '/htmodel',
      component: resolve => require(['./htmodelIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/htmodel/_router.js